import { HttpClient } from "@angular/common/http";
import { Order as IOrder, OrderParams } from "@helper/abstraction/order";
import { ConfigurationService } from "@core/configuration.service";
import { DocumentController } from "./document-controller";
import { Observable } from "rxjs";
import { ShipmentNotification } from "@app/user/documents/shipment-notification/shipment-notification";
import { DocumentFromAnotherParams } from "@helper/abstraction/documents";
import { Ewaybill, ResponseDraftInfo } from "@helper/abstraction/ewaybill";

export class Order extends DocumentController<IOrder> {
	public get apiUrl(): string { return `${this.config.api.order}`; }

	public convertToDraft = {
		DESADV: {
			post$: (orderId: number): Observable<ShipmentNotification> => {
				const url = `${this.apiUrl}/${orderId}/convertToDraftDesadv`;
				return this.http.post(url, {}, { withCredentials: true });
			}
		},
		EWAYBILL: {
			post$: (orderId: number, documentFromAnotherParams: DocumentFromAnotherParams, isVersion = false): Observable<Ewaybill> => {
				const url = `${this.config.handleVersionPath(this.apiUrl, isVersion ? undefined : "")}/${orderId}/convertToDraftEwaybill`;
				delete documentFromAnotherParams.id;
				delete documentFromAnotherParams.sourceDocumentType;
				return this.http.post<Ewaybill>(url, documentFromAnotherParams, { withCredentials: true });
			}
		}
	};

	public saveBasedOnOrderOrdrsp = {
		post$: (orderId: number): Observable<ResponseDraftInfo> => {
			const url = `${this.apiUrl}/draft/response/saveBasedOnOrderOrdrsp/${orderId}`;
			return this.http.post<ResponseDraftInfo>(url, undefined, { withCredentials: true });
		}
	};

	public getOrderFromAnother = {
		post$: (orderId: number): Observable<OrderParams> => {
			const url = `${this.apiUrl}/${orderId}/getDocumentFromAnother`;
			return this.http.post<OrderParams>(url, { orderId }, { withCredentials: true });
		}
	};

	constructor(
		private config: ConfigurationService,
		http: HttpClient
	) {
		super(http);
	}
}
